import { Component, Input, OnInit } from '@angular/core';
import { FormControlBase } from '../form-control-base/form-control-base';

@Component({
    selector: 'form-control-container',
    templateUrl: './form-control-container.component.html',
    styleUrls: ['./form-control-container.component.scss'],
    standalone: false
})
export class FormControlContainerComponent {
  @Input()
  control: FormControlBase<any>;
}
